<template>
  <div id="contract" class="content">
    <div class="section-title">
      <div class="row">
        <div class="col-md-7">
          <h3>{{ title }}</h3>
        </div>
        <div class="col-md-5">
          <div class="userLog_bread">
            <span v-if="userLogged">
              {{
                userLogged.comercialName
                  ? userLogged.comercialName
                  : userLogged.name + " " + userLogged.lastName
              }}
            </span>
          </div>
        </div>
      </div>
      <hr />
    </div>
    <div class="block" style="margin-top: 25px">
      <label style="margin-bottom: 25px"
        >DATOS IDENTIFICATIVOS DEL CLIENTE</label
      >
      <el-form
        :model="personalInfo"
        name="personalInfoForm"
        :rules="personalInfoRules"
        status-icon
        ref="personalInfoForm"
      >
        <div class="row">
          <div class="col-md-4">
            <el-form-item prop="name">
              <el-input
                v-model="personalInfo.name"
                autocomplete="off"
                readonly
                placeholder="*Nombre"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-md-8">
            <el-form-item prop="lastName">
              <el-input
                v-model="personalInfo.lastName"
                autocomplete="off"
                readonly
                placeholder="*Apellidos"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <el-form-item prop="email">
              <el-input
                v-model="personalInfo.email"
                autocomplete="off"
                readonly
                placeholder="*Email"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-md-2">
            <el-form-item prop="phone">
              <el-input
                v-model="personalInfo.phone"
                autocomplete="off"
                readonly
                placeholder="*Teléfono"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-md-2">
            <el-form-item prop="phone2">
              <el-input
                v-model="personalInfo.phone2"
                autocomplete="off"
                placeholder="2º teléfono"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-md-2">
            <el-select
              v-model="personalInfo.documentTypeSelected"
              placeholder="Tipo de documento"
              @change="clearNif"
            >
              <el-option
                v-for="item in personalInfo.documentType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-md-2">
            <el-form-item prop="documentValue">
              <el-input
                v-model="personalInfo.documentValue"
                autocomplete="off"
                placeholder="*Identificación"
                @focus="sessionExpired"
                @change="getNationalities"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-md-4">
            <el-form-item prop="nationality">
              <el-select 
                filterable
                style="width: 100%"
                v-model="personalInfo.nationality"
                ref="nationalitySelect"
                name="searchnationality"
                placeholder="Seleccionar nacionalidad"
                clearable
              >
                <el-option
                  v-for="nationality in nationalities"
                  :key="nationality.value"
                  :label="nationality.label"
                  :value="nationality.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="col-md-2">
            <el-form-item class="check" prop="checkParticular">
              <el-checkbox
                v-model="personalInfo.checkParticular"
                @change="particularChecked"
              ></el-checkbox>
              <span class="pointer"> Particular </span>
            </el-form-item>
          </div>
          <div class="col-md-2">
            <el-form-item class="check" prop="checkEmpresa">
              <el-checkbox
                v-model="personalInfo.checkEmpresa"
                @change="empresaChecked"
              ></el-checkbox>
              <span class="pointer"> Empresa </span>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <label class="mt-4 mb-4">DIRECCION DE SUMINISTRO</label>
      <el-form
        :model="addressInfo"
        name="addressInfoForm"
        :rules="addressRules"
        status-icon
        ref="addressInfoForm"
      >
        <div class="row">
          <div class="col-md-6">
            <el-form-item prop="location">
              <el-input
                v-model="addressInfo.location"
                autocomplete="off"
                placeholder="*Localidad"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-md-3">
            <el-form-item prop="province">
              <el-input
                v-model="addressInfo.province"
                autocomplete="off"
                placeholder="*Provincia"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-md-3">
            <el-form-item prop="postalCode">
              <el-input
                v-model="addressInfo.postalCode"
                autocomplete="off"
                placeholder="*Código postal"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-9">
            <el-form-item prop="address">
              <el-input
                v-model="addressInfo.address"
                autocomplete="off"
                placeholder="*Dirección"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-md-3">
            <el-form-item prop="number">
              <el-input
                v-model="addressInfo.number"
                autocomplete="off"
                placeholder="*Numero"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <el-form-item prop="portal">
              <el-input
                v-model="addressInfo.portal"
                autocomplete="off"
                placeholder="Portal"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-md-3">
            <el-form-item prop="stair">
              <el-input
                v-model="addressInfo.stair"
                autocomplete="off"
                placeholder="Escalera"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-md-3">
            <el-form-item prop="floor">
              <el-input
                v-model="addressInfo.floor"
                autocomplete="off"
                placeholder="Piso"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
          <div class="col-md-3">
            <el-form-item prop="door">
              <el-input
                v-model="addressInfo.door"
                autocomplete="off"
                placeholder="Puerta"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <label class="mt-4 mb-4">IBAN</label>
      <el-form
        :model="ibanInfo"
        name="ibanInfoForm"
        :rules="ibanRules"
        status-icon
        ref="ibanInfoForm"
      >
        <div class="row">
          <div class="col-md-12">
            <el-form-item prop="iban">
              <el-input
                v-model="ibanInfo.iban"
                autocomplete="off"
                placeholder="*IBAN (ESXX XXXX XXXX XX XXXXXXXXXX)"
                @focus="sessionExpired"
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>

      <hr />
      <label style="margin-bottom: 25px; margin-top: 25px"
        >CONDICIONES DE LA OFERTA</label
      >
      <el-form
        :model="offerInfo"
        name="offerInfoForm"
        status-icon
        ref="offerInfoForm"
      >
        <div class="row">
          <!-- PRODUCTO FIJO -->
          <div
            v-if="offerInfo.fijoOffer"
            :class="(offerInfo.gasOffer || offerInfo.gasHoyOffer || offerInfo.gasSimpleOffer) ? 'col-xl-6' : 'col-12'"
          >
            <div class="box">
              <div class="row mb-3">
                <div class="col-md-12">
                  <label>
                    Producto contratado:
                    <span class="offer-title-label offer-pink-label"
                      >FIJO</span
                    ></label
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="offer-normal-label"
                    ><strong>CUPS Electricidad:</strong></label
                  >
                </div>
                <div class="col-lg-8 col-md-12">
                  <el-form-item prop="fijoCups">
                    <el-input
                      v-model="cupsInfo.electricityCups"
                      autocomplete="off"
                      placeholder="CUPS"
                      readonly
                      @focus="sessionExpired"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="offer-normal-label"
                    ><strong>Potencia contratada:</strong></label
                  >
                </div>
                <div class="col-lg-8 col-md-12">
                  <el-form-item prop="fijoPotencia">
                    <el-input
                      v-model="
                        offerInfo.fijoOffer.p_contratada_electricidad_Formated
                      "
                      autocomplete="off"
                      readonly
                      @focus="sessionExpired"
                    >
                      <template slot="append">kW</template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="row mt-2">
                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <label class="offer-normal-label"
                    ><strong>Precio de energía,</strong> por kWh
                    consumido:</label
                  >
                </div>

                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <div class="row">
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-7 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <el-form-item prop="fijoPriceSimp">
                        <el-input
                          v-model="offerInfo.fijoOffer.luzp1simp_Formated"
                          autocomplete="off"
                          readonly
                          @focus="sessionExpired"
                        >
                          <template slot="append">€/kWh</template>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-5 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <label class="offer-small-label">(sin impuestos)</label>
                    </div>
                  </div>
                </div>

                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <div class="row">
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-7 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <el-form-item prop="fijoPriceSimp">
                        <el-input
                          v-model="offerInfo.fijoOffer.luzp1cimp_Formated"
                          autocomplete="off"
                          readonly
                          @focus="sessionExpired"
                        >
                          <template slot="append">€/kWh</template>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-5 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <label class="offer-small-label">(con impuestos)</label>
                    </div>
                  </div>
                </div>

                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <label class="offer-normal-label"
                    ><strong>Cuota mensual fija,</strong> que incluye la
                    potencia contratada y el alquiler del contador:</label
                  >
                </div>

                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <div class="row">
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-7 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <el-form-item prop="fijoCuotaSimp">
                        <el-input
                          v-model="offerInfo.fijoOffer.cuota_luz_simp_Formated"
                          autocomplete="off"
                          readonly
                          @focus="sessionExpired"
                        >
                          <template slot="append">€/Mes</template>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-5 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <label class="offer-small-label">(sin impuestos)</label>
                    </div>
                  </div>
                </div>

                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <div class="row">
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-7 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <el-form-item prop="fijoCuotaCimp">
                        <el-input
                          v-model="offerInfo.fijoOffer.cuota_luz_cimp_Formated"
                          autocomplete="off"
                          readonly
                          @focus="sessionExpired"
                        >
                          <template slot="append">€/Mes</template>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-5 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <label class="offer-small-label">(con impuestos)</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="float-right">
                <label class="offer-normal-label offer-pink-label float-right"
                  >Sujeto a permanencia</label
                >
              </div>
            </div>
          </div>

          <!-- PRODUCTO FLEXI UNO -->
          <div
            v-if="offerInfo.flexiOffer"
            :class="(offerInfo.gasOffer || offerInfo.gasHoyOffer || offerInfo.gasSimpleOffer) ? 'col-xl-6' : 'col-12'"
          >
            <div class="box">
              <div class="row mb-3">
                <div class="col-md-12">
                  <label>
                    Producto contratado:
                    <span class="offer-title-label offer-pink-label"
                      >FLEXI UNO</span
                    ></label
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="offer-normal-label"
                    ><strong>CUPS Electricidad:</strong></label
                  >
                </div>
                <div class="col-lg-8 col-md-12">
                  <el-form-item prop="flexiCups">
                    <el-input
                      v-model="cupsInfo.electricityCups"
                      autocomplete="off"
                      placeholder="CUPS"
                      readonly
                      @focus="sessionExpired"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="offer-normal-label"
                    ><strong>Potencia contratada:</strong></label
                  >
                </div>
                <div class="col-lg-8 col-12">
                  <el-form-item prop="flexiPotencia">
                    <el-input
                      v-model="
                        offerInfo.flexiOffer.p_contratada_electricidad_Formated
                      "
                      autocomplete="off"
                      readonly
                      @focus="sessionExpired"
                    >
                      <template slot="append">kW</template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="row mt-2">
                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <label class="offer-normal-label"
                    ><strong>Precio de energía,</strong> por kWh
                    consumido:</label
                  >
                </div>

                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <div class="row">
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-7 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <el-form-item prop="flexiPriceSimp">
                        <el-input
                          v-model="offerInfo.flexiOffer.luzp1simp_Formated"
                          autocomplete="off"
                          readonly
                          @focus="sessionExpired"
                        >
                          <template slot="append">€/kWh</template>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-5 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <label class="offer-small-label">(sin impuestos)</label>
                    </div>
                  </div>
                </div>

                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <div class="row">
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-7 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <el-form-item prop="flexiPriceCimp">
                        <el-input
                          v-model="offerInfo.flexiOffer.luzp1cimp_Formated"
                          autocomplete="off"
                          readonly
                          @focus="sessionExpired"
                        >
                          <template slot="append">€/kWh</template>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-5 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <label class="offer-small-label">(con impuestos)</label>
                    </div>
                  </div>
                </div>

                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <label class="offer-normal-label"
                    ><strong>Cuota mensual fija,</strong> que incluye la
                    potencia contratada y el alquiler del contador:</label
                  >
                </div>

                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <div class="row">
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-7 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <el-form-item prop="flexiCuotaSimp">
                        <el-input
                          v-model="offerInfo.flexiOffer.cuota_luz_simp_Formated"
                          autocomplete="off"
                          readonly
                          @focus="sessionExpired"
                        >
                          <template slot="append">€/Mes</template>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-5 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <label class="offer-small-label">(sin impuestos)</label>
                    </div>
                  </div>
                </div>

                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <div class="row">
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-7 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <el-form-item prop="flexiCuotaCimp">
                        <el-input
                          v-model="offerInfo.flexiOffer.cuota_luz_cimp_Formated"
                          autocomplete="off"
                          readonly
                          @focus="sessionExpired"
                        >
                          <template slot="append">€/Mes</template>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-5 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <label class="offer-small-label">(con impuestos)</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="float-right">
                <label class="offer-normal-label offer-pink-label float-right"
                  >Sujeto a permanencia</label
                >
              </div>
            </div>
          </div>

          <!-- PRODUCTO SIMPLE -->
          <div
            v-if="offerInfo.simpleOffer"
            :class="(offerInfo.gasOffer || offerInfo.gasHoyOffer || offerInfo.gasSimpleOffer) ? 'col-xl-6' : 'col-12'"
          >
            <div class="box">
              <div class="row mb-3">
                <div class="col-md-12">
                  <label>
                    Producto contratado:
                    <span class="offer-title-label offer-pink-label"
                      >SIMPLE</span
                    ></label
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="offer-normal-label"
                    ><strong>CUPS Electricidad:</strong></label
                  >
                </div>
                <div class="col-lg-8 col-md-12">
                  <el-form-item prop="flexiCups">
                    <el-input
                      v-model="cupsInfo.electricityCups"
                      autocomplete="off"
                      placeholder="CUPS"
                      readonly
                      @focus="sessionExpired"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="offer-normal-label"
                    ><strong>Potencia contratada:</strong></label
                  >
                </div>
                <div class="col-lg-8 col-12">
                  <el-form-item prop="flexiPotencia">
                    <el-input
                      v-model="
                        offerInfo.simpleOffer.p_contratada_electricidad_Formated
                      "
                      autocomplete="off"
                      readonly
                      @focus="sessionExpired"
                    >
                      <template slot="append">kW</template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="row mt-2">
                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <label class="offer-normal-label"
                    ><strong>Cuota mensual fija,</strong> que incluye la
                    potencia contratada y el alquiler del contador:</label
                  >
                </div>

                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <div class="row">
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-7 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <el-form-item prop="flexiCuotaSimp">
                        <el-input
                          v-model="offerInfo.simpleOffer.cuota_luz_simp_Formated"
                          autocomplete="off"
                          readonly
                          @focus="sessionExpired"
                        >
                          <template slot="append">€/Mes</template>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-5 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <label class="offer-small-label">(sin impuestos)</label>
                    </div>
                  </div>
                </div>

                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <div class="row">
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-7 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <el-form-item prop="flexiCuotaCimp">
                        <el-input
                          v-model="offerInfo.simpleOffer.cuota_luz_cimp_Formated"
                          autocomplete="off"
                          readonly
                          @focus="sessionExpired"
                        >
                          <template slot="append">€/Mes</template>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-5 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <label class="offer-small-label">(con impuestos)</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="float-right">
                <label class="offer-normal-label offer-pink-label float-right"
                  >Sujeto a permanencia</label
                >
              </div>
            </div>
          </div>

          <!-- PRODUCTO HOY -->
          <div
            v-if="offerInfo.hoyOffer"
            :class="(offerInfo.gasOffer || offerInfo.gasHoyOffer || offerInfo.gasSimpleOffer) ? 'col-xl-6' : 'col-12'"
          >
            <div class="box">
              <div class="row mb-3">
                <div class="col-md-12">
                  <label>
                    Producto contratado:
                    <span class="offer-title-label offer-pink-label"
                      >FLEXI HOY</span
                    ></label
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="offer-normal-label"
                    ><strong>CUPS Electricidad:</strong></label
                  >
                </div>
                <div class="col-lg-8 col-md-12">
                  <el-form-item prop="flexiCups">
                    <el-input
                      v-model="cupsInfo.electricityCups"
                      autocomplete="off"
                      placeholder="CUPS"
                      readonly
                      @focus="sessionExpired"
                    ></el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-4 col-md-12">
                  <label class="offer-normal-label"
                    ><strong>Potencia contratada:</strong></label
                  >
                </div>
                <div class="col-lg-8 col-12">
                  <el-form-item prop="flexiPotencia">
                    <el-input
                      v-model="
                        offerInfo.hoyOffer.p_contratada_electricidad_Formated
                      "
                      autocomplete="off"
                      readonly
                      @focus="sessionExpired"
                    >
                      <template slot="append">kW</template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="row mt-2">
                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <label class="offer-normal-label"
                    ><strong>Precio de energía,</strong> por kWh
                    consumido:</label
                  >
                </div>

                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <div class="row">
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-7 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <el-form-item prop="flexiPriceSimp">
                        <el-input
                          v-model="offerInfo.hoyOffer.luzp1simp_Formated"
                          autocomplete="off"
                          readonly
                          @focus="sessionExpired"
                        >
                          <template slot="append">€/kWh</template>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-5 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <label class="offer-small-label">(sin impuestos)</label>
                    </div>
                  </div>
                </div>

                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <div class="row">
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-7 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <el-form-item prop="flexiPriceCimp">
                        <el-input
                          v-model="offerInfo.hoyOffer.luzp1cimp_Formated"
                          autocomplete="off"
                          readonly
                          @focus="sessionExpired"
                        >
                          <template slot="append">€/kWh</template>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-5 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <label class="offer-small-label">(con impuestos)</label>
                    </div>
                  </div>
                </div>

                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <label class="offer-normal-label"
                    ><strong>Cuota mensual fija,</strong> que incluye la
                    potencia contratada y el alquiler del contador:</label
                  >
                </div>

                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <div class="row">
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-7 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <el-form-item prop="flexiCuotaSimp">
                        <el-input
                          v-model="offerInfo.hoyOffer.cuota_luz_simp_Formated"
                          autocomplete="off"
                          readonly
                          @focus="sessionExpired"
                        >
                          <template slot="append">€/Mes</template>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-5 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <label class="offer-small-label">(sin impuestos)</label>
                    </div>
                  </div>
                </div>

                <div
                  :class="(!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer) ? 'col-xl-4 col-12' : 'col-12'"
                >
                  <div class="row">
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-7 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <el-form-item prop="flexiCuotaCimp">
                        <el-input
                          v-model="offerInfo.hoyOffer.cuota_luz_cimp_Formated"
                          autocomplete="off"
                          readonly
                          @focus="sessionExpired"
                        >
                          <template slot="append">€/Mes</template>
                        </el-input>
                      </el-form-item>
                    </div>
                    <div
                      :class="
                        (!offerInfo.gasOffer && !offerInfo.gasHoyOffer && !offerInfo.gasSimpleOffer)
                          ? 'col-lg-5 col-sm-6 col-12'
                          : 'col-sm-6 col-12'
                      "
                    >
                      <label class="offer-small-label">(con impuestos)</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="float-right">
                <label class="offer-normal-label offer-pink-label float-right"
                  >Sujeto a permanencia</label
                >
              </div>
            </div>
          </div>

          <!-- PRODUCTO GAS -->
          <div
            :class="
              (offerInfo.fijoOffer || offerInfo.flexiOffer || offerInfo.hoyOffer || offerInfo.simpleOffer)
                ? 'col-xl-6'
                : 'col-12'
            "
          >
            <!-- FLEXI GAS-->
            <div
              v-if="offerInfo.gasOffer"
              class="box"
              :class="
                (offerInfo.fijoOffer || offerInfo.flexiOffer || offerInfo.hoyOffer || offerInfo.simpleOffer) ? 'mt-0' : 'mt-2'
              "
            >
              <div class="">
                <div class="row mb-3">
                  <div class="col-md-12">
                    <label>
                      Producto contratado:
                      <span class="offer-title-label offer-pink-label"
                        >FLEXI GAS {{ offerInfo.gasOffer.peajegas }}</span
                      ></label
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-4 col-md-12">
                    <label class="offer-normal-label"
                      ><strong>CUPS gas:</strong></label
                    >
                  </div>
                  <div class="col-lg-8 col-md-12">
                    <el-form-item prop="flexiGasCups">
                      <el-input
                        v-model="cupsInfo.gasCups"
                        autocomplete="off"
                        placeholder="CUPS"
                        readonly
                        @focus="sessionExpired"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>

                <div class="row margin-space">
                  <div class="col-12">
                    <label class="offer-normal-label mt-0"
                      ><strong>Precio de energía,</strong> por kWh
                      consumido:</label
                    >
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-sm-6 col-12">
                        <el-form-item prop="flexiPriceSimp">
                          <el-input
                            v-model="offerInfo.gasOffer.gassimp_Formated"
                            autocomplete="off"
                            readonly
                            @focus="sessionExpired"
                          >
                            <template slot="append">€/kWh</template>
                          </el-input>
                        </el-form-item>
                      </div>
                      <div class="col-sm-6 col-12">
                        <label class="offer-small-label">(sin impuestos)</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-sm-6 col-12">
                        <el-form-item prop="flexiGasPriceCimp">
                          <el-input
                            v-model="offerInfo.gasOffer.gascimp_Formated"
                            autocomplete="off"
                            readonly
                            @focus="sessionExpired"
                          >
                            <template slot="append">€/kWh</template>
                          </el-input>
                        </el-form-item>
                      </div>
                      <div class="col-sm-6 col-12">
                        <label class="offer-small-label">(con impuestos)</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <label class="offer-normal-label mt-3"
                      ><strong>Cuota mensual fija,</strong> que incluye el
                      término de peaje fijo y el alquiler del contador:</label
                    >
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-sm-6 col-12">
                        <el-form-item prop="flexiGasCuotaSimp">
                          <el-input
                            v-model="offerInfo.gasOffer.cuota_gas_simp_Formated"
                            autocomplete="off"
                            readonly
                            @focus="sessionExpired"
                          >
                            <template slot="append">€/mes</template>
                          </el-input>
                        </el-form-item>
                      </div>
                      <div class="col-sm-6 col-12">
                        <label class="offer-small-label">(sin impuestos)</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-sm-6 col-12">
                        <el-form-item prop="flexiGasCuotaCimp">
                          <el-input
                            v-model="offerInfo.gasOffer.cuota_gas_cimp_Formated"
                            autocomplete="off"
                            readonly
                            @focus="sessionExpired"
                          >
                            <template slot="append">€/mes</template>
                          </el-input>
                        </el-form-item>
                      </div>
                      <div class="col-sm-6 col-12">
                        <label class="offer-small-label">(con impuestos)</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="float-right">
                  <label class="offer-normal-label offer-pink-label float-right"
                    >Sujeto a permanencia</label
                  >
                </div>
              </div>
            </div>
            <!-- FLEXI GAS HOY-->
            <div
              v-if="offerInfo.gasHoyOffer"
              class="box"
              :class="
                (offerInfo.fijoOffer || offerInfo.flexiOffer || offerInfo.hoyOffer || offerInfo.simpleOffer) ? 'mt-0' : 'mt-2'
              "
            >
              <div class="">
                <div class="row mb-3">
                  <div class="col-md-12">
                    <label>
                      Producto contratado:
                      <span class="offer-title-label offer-pink-label"
                        >FLEXI GAS HOY </span
                      ></label
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-4 col-md-12">
                    <label class="offer-normal-label"
                      ><strong>CUPS gas:</strong></label
                    >
                  </div>
                  <div class="col-lg-8 col-md-12">
                    <el-form-item prop="flexiGasCups">
                      <el-input
                        v-model="cupsInfo.gasCups"
                        autocomplete="off"
                        placeholder="CUPS"
                        readonly
                        @focus="sessionExpired"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>

                <div class="row margin-space">
                  <div class="col-12">
                    <label class="offer-normal-label mt-0"
                      ><strong>Precio de energía,</strong> por kWh
                      consumido:</label
                    >
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-sm-6 col-12">
                        <el-form-item prop="flexiPriceSimp">
                          <el-input
                            v-model="offerInfo.gasHoyOffer.gassimp_Formated"
                            autocomplete="off"
                            readonly
                            @focus="sessionExpired"
                          >
                            <template slot="append">€/kWh</template>
                          </el-input>
                        </el-form-item>
                      </div>
                      <div class="col-sm-6 col-12">
                        <label class="offer-small-label">(sin impuestos)</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-sm-6 col-12">
                        <el-form-item prop="flexiGasPriceCimp">
                          <el-input
                            v-model="offerInfo.gasHoyOffer.gascimp_Formated"
                            autocomplete="off"
                            readonly
                            @focus="sessionExpired"
                          >
                            <template slot="append">€/kWh</template>
                          </el-input>
                        </el-form-item>
                      </div>
                      <div class="col-sm-6 col-12">
                        <label class="offer-small-label">(con impuestos)</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <label class="offer-normal-label mt-3"
                      ><strong>Cuota mensual fija,</strong> que incluye el
                      término de peaje fijo y el alquiler del contador:</label
                    >
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-sm-6 col-12">
                        <el-form-item prop="flexiGasCuotaSimp">
                          <el-input
                            v-model="offerInfo.gasHoyOffer.cuota_gas_simp_Formated"
                            autocomplete="off"
                            readonly
                            @focus="sessionExpired"
                          >
                            <template slot="append">€/mes</template>
                          </el-input>
                        </el-form-item>
                      </div>
                      <div class="col-sm-6 col-12">
                        <label class="offer-small-label">(sin impuestos)</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-sm-6 col-12">
                        <el-form-item prop="flexiGasCuotaCimp">
                          <el-input
                            v-model="offerInfo.gasHoyOffer.cuota_gas_cimp_Formated"
                            autocomplete="off"
                            readonly
                            @focus="sessionExpired"
                          >
                            <template slot="append">€/mes</template>
                          </el-input>
                        </el-form-item>
                      </div>
                      <div class="col-sm-6 col-12">
                        <label class="offer-small-label">(con impuestos)</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="float-right">
                  <label class="offer-normal-label offer-pink-label float-right"
                    >Sujeto a permanencia</label
                  >
                </div>
              </div>
            </div>

            <!-- FLEXI GAS SIMPLE-->
            <div
              v-if="offerInfo.gasSimpleOffer"
              class="box"
              :class="
                (offerInfo.fijoOffer || offerInfo.flexiOffer || offerInfo.hoyOffer || offerInfo.simpleOffer) ? 'mt-0' : 'mt-2'
              "
            >
              <div class="">
                <div class="row mb-3">
                  <div class="col-md-12">
                    <label>
                      Producto contratado:
                      <span class="offer-title-label offer-pink-label"
                        >FLEXI GAS SIMPLE</span
                      ></label
                    >
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-4 col-md-12">
                    <label class="offer-normal-label"
                      ><strong>CUPS gas:</strong></label
                    >
                  </div>
                  <div class="col-lg-8 col-md-12">
                    <el-form-item prop="flexiGasCups">
                      <el-input
                        v-model="cupsInfo.gasCups"
                        autocomplete="off"
                        placeholder="CUPS"
                        readonly
                        @focus="sessionExpired"
                      ></el-input>
                    </el-form-item>
                  </div>
                </div>

                <div class="row margin-space">
                  <div class="col-12">
                    <label class="offer-normal-label mt-0"
                      ><strong>Precio de energía,</strong> por kWh
                      consumido:</label
                    >
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-sm-6 col-12">
                        <el-form-item prop="flexiPriceSimp">
                          <el-input
                            v-model="offerInfo.gasSimpleOffer.gassimp_Formated"
                            autocomplete="off"
                            readonly
                            @focus="sessionExpired"
                          >
                            <template slot="append">€/kWh</template>
                          </el-input>
                        </el-form-item>
                      </div>
                      <div class="col-sm-6 col-12">
                        <label class="offer-small-label">(sin impuestos)</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-sm-6 col-12">
                        <el-form-item prop="flexiGasPriceCimp">
                          <el-input
                            v-model="offerInfo.gasSimpleOffer.gascimp_Formated"
                            autocomplete="off"
                            readonly
                            @focus="sessionExpired"
                          >
                            <template slot="append">€/kWh</template>
                          </el-input>
                        </el-form-item>
                      </div>
                      <div class="col-sm-6 col-12">
                        <label class="offer-small-label">(con impuestos)</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <label class="offer-normal-label mt-3"
                      ><strong>Cuota mensual fija,</strong> que incluye el
                      término de peaje fijo y el alquiler del contador:</label
                    >
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-sm-6 col-12">
                        <el-form-item prop="flexiGasCuotaSimp">
                          <el-input
                            v-model="offerInfo.gasSimpleOffer.cuota_gas_simp_Formated"
                            autocomplete="off"
                            readonly
                            @focus="sessionExpired"
                          >
                            <template slot="append">€/mes</template>
                          </el-input>
                        </el-form-item>
                      </div>
                      <div class="col-sm-6 col-12">
                        <label class="offer-small-label">(sin impuestos)</label>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-sm-6 col-12">
                        <el-form-item prop="flexiGasCuotaCimp">
                          <el-input
                            v-model="offerInfo.gasSimpleOffer.cuota_gas_cimp_Formated"
                            autocomplete="off"
                            readonly
                            @focus="sessionExpired"
                          >
                            <template slot="append">€/mes</template>
                          </el-input>
                        </el-form-item>
                      </div>
                      <div class="col-sm-6 col-12">
                        <label class="offer-small-label">(con impuestos)</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="float-right">
                  <label class="offer-normal-label offer-pink-label float-right"
                    >Sujeto a permanencia</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-form>
      <el-form
        :model="checkInfo"
        name="checkInfoForm"
        status-icon
        :rules="checkInfoRules"
        ref="checkInfoForm"
      >
        <div class="row mt-4">
          <div class="col-md-12">
            <el-form-item class="check contract-check mb-1" prop="serviceCheck">
              <el-checkbox v-model="checkInfo.serviceCheck"></el-checkbox>
              <span style="margin-left: 10px"
                >* Acepto que Podo inicie el servicio de inmediato y por tanto
                antes de finalizar el
                <a
                  class="pointer"
                  @click="
                    modalMsgContent = 'Esta aceptación solo supone que Podo podrá iniciar el suministro durante el periodo de desistimiento. Podrás ejercer tu derecho de desistimiento en todo caso durante los 14 días naturales siguientes a la contratación abonando únicamente el coste de los días en los que se haya prestado el servicio.';
                    showModalMsg = true;
                  "
                >
                  periodo de desistimiento
                </a>
              </span>
            </el-form-item>
          </div>
          <div class="col-md-12">
            <el-form-item class="check contract-check mb-1" prop="comercial">
              <el-checkbox v-model="checkInfo.comercialCheck"></el-checkbox>
              <span style="margin-left: 10px"
                >Deseo recibir comunicaciones comerciales de terceras entidades
                en los términos previstos en la
                <a class="pointer" @click="showPrivacyPolicyModal = true">
                  política de privacidad</a
                >
              </span>
            </el-form-item>
          </div>
          <div class="col-md-12">
            <el-form-item class="check contract-check" prop="customOffers">
              <el-checkbox v-model="checkInfo.customOffersCheck"></el-checkbox>
              <span style="margin-left: 10px"
                >Deseo que Podo me remita ofertas personalizadas en los términos
                previstos en la
                <a class="pointer" @click="showPrivacyPolicyModal = true">
                  política de privacidad</a
                >
              </span>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 text-right">
            <div class="buttons">
              <el-button
                class="btn btn_secondary"
                @click="
                  cancelModal = true;
                  showModal = true;
                "
              >
                Cancelar
              </el-button>
              <el-button class="btn btn_gradient" @click="sendContract()">
                Contratar oferta
              </el-button>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <Modal
      v-if="showModal"
      :size="'small'"
      :theme="'pink'"
      @close="
        showModal = false;
        cancelModal = false;
      "
    >
      <template v-slot:content>
        <div v-if="cancelModal" class="text-center row">
          <div class="row">
            <div class="col-md-12" style="margin-bottom: 25px">
              <label>
                ¿Estas seguro de que quieres cancelar la operación?
              </label>
            </div>
            <div class="col-md-6 text-center">
              <button
                class="btn"
                style="width: 100%"
                @click="
                  showModal = false;
                  cancelModal = false;
                "
              >
                Cancelar
              </button>
            </div>
            <div class="col-md-6 text-center">
              <button
                class="btn"
                style="width: 100%"
                @click="
                  showModal = false;
                  cancelModal = false;
                  acceptButton();
                "
              >
                Aceptar
              </button>
            </div>
          </div>
        </div>
      </template>
    </Modal>

    <!-- Modal de mostrar mensaje -->
    <Modal
      v-if="showModalMsg"
      :size="'small'"
      :theme="'pink'"
      @close="showModalMsg = false"
    >
      <template v-slot:content>
        <div class="text-center" id="text">
          <label>{{ modalMsgContent }}</label>
          <button
            class="btn"
            style="margin: 40px 0px"
            @click="showModalMsg = false"
          >
            Aceptar
          </button>
        </div>
      </template>
    </Modal>

    <!-- Modal de finalizacion de contrato -->
    <Modal
      v-if="showModalEnd"
      :size="'small'"
      :theme="'pink'"
      @close="
        showModalEnd = false;
        endContract();
      "
    >
      <template v-slot:content>
        <div class="text-center" id="text">
          <label>{{ modalEndMsg }}</label>
          <button
            class="btn"
            style="margin: 40px 0px"
            @click="
              showModalEnd = false;
              endContract();
            "
          >
            Aceptar
          </button>
        </div>
      </template>
    </Modal>

    <!-- Modal de error de validación -->
    <Modal
      v-if="showErrorValidationModal"
      :size="'small'"
      :theme="'pink'"
      @close="showErrorValidationModal = false"
    >
      <template v-slot:content>
        <div class="text-center" id="text">
          <label>Los siguientes campos no están correctos: </label>
          <ul style="margin:0;padding:0;">
            <li v-for="(message, index) in errorsValidation" :key="index">
              <span style="color: white">{{ message }}</span>
            </li>
          </ul>
          <button
            class="btn"
            style="margin: 40px 0px"
            @click="showErrorValidationModal = false"
          >
            Aceptar
          </button>
        </div>
      </template>
    </Modal>

    <!-- Modal de iFrame -->
    <IFrameSpecialModal
      v-if="showIframeModal"
      :size="'large'"
      :theme="'pink'"
      :customHeight="true"
      :customWidth="true"
      @close="
        showIframeModal = false;
        endContractMessage();
      "
    >
      <template v-slot:content>
        <div class="iframe-div-container">
          <iframe
            :src="iframeURL"
            title="Firma de contrato"
            class="iframe-modal-element"
          ></iframe>
        </div>
      </template>
    </IFrameSpecialModal>

    <!-- Modal de política de privacidad -->
    <Modal
      v-if="showPrivacyPolicyModal"
      :size="'medium'"
      :theme="'white'"
      :title="'INFORMACIÓN BÁSICA SOBRE PROTECCIÓN DE DATOS'"
      @close="showPrivacyPolicyModal = false"
    >
      <template v-slot:content>
        <div id="text">
          <br />
          <table
            style="border-collapse: collapse"
            border="1"
            width="100%"
            cellspacing="0"
            cellpadding="0"
          >
            <tbody>
              <tr>
                <th>Responsable:<br />(Tratamiento)</th>
                <td>
                  GEO ALTERNATIVA, S.L<br />
                  (C/Calle Antonio Maura, 18, 2º B,28014 – Madrid. CIF B
                  87382644
                </td>
              </tr>
              <tr>
                <th>Finalidad:</th>
                <td>Envío de información y/o gestión de los servicios.</td>
              </tr>
              <tr>
                <th>Legitimación:</th>
                <td>Ejecución del contrato y/o consentimiento expreso.</td>
              </tr>
              <tr>
                <th>Derechos:</th>
                <td>
                  Acceso, Rectificación, Supresión, Oposición, Limitación y
                  Portabilidad.
                </td>
              </tr>
              <tr>
                <th>Destinatarios:</th>
                <td>No serán cedidos a terceros.</td>
              </tr>
              <tr>
                <th>Ejercicio de derechos:</th>
                <td>
                  Correo Electrónico
                  <a style="font-weight: 100;border-bottom: none;">
                    dpo@mipodo.com
                  </a>
                </td>
              </tr>
              <tr>
                <th>Más Información:</th>
                <td>
                  Consulta la
                  <a
                    style="font-weight: 100;"
                    :href="urlPdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Política de privacidad en nuestra web.
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/Modal";
import IFrameSpecialModal from "@/components/IFrameSpecialModal";
import AuthService from "@/services/auth.service";
import ContractService from "@/services/contract.service";
import { Loading } from "element-ui";

import { mapState } from "vuex";
import Lead from "../../model/Lead";

import ENV from "@/utils/constants/environment";
import offerService from "@/services/offer.service";
const BASE_URL = ENV.PDF_URI + "recursos/politica_privacidad.pdf";

export default {
  name: "Contract",
  components: { Modal, IFrameSpecialModal },
  computed: {
    ...mapState({
      userLogged: "user"
    })
  },
  mounted() {
    document.querySelector("#app").scrollTop = 0;
    const offer = JSON.parse(localStorage.getItem("offer"));
    if (offer) {
      this.personalInfo = {
        ...offer.personalInfo,
        documentType: [
          { label: "DNI", value: "NIF" },
          { label: "CIF", value: "CIF" },
          { label: "NIE", value: "NIE" },
          { label: "PASAPORTE", value: "PASAPORTE" }
        ],
        documentTypeSelected: "NIF",
        documentValue: null
      };
      this.addressInfo = offer.addressInfo;
      this.addressInfo.location = offer.addressInfo.location;
      this.addressInfo.province = offer.addressInfo.province;
      this.addressInfo.postalCode = offer.addressInfo.postalCode;
      this.addressInfo.address = offer.addressInfo.address;
      this.addressInfo.number = offer.addressInfo.number;
      this.addressInfo.portal = offer.addressInfo.portal;
      this.addressInfo.stair = offer.addressInfo.stair;
      this.addressInfo.floor = offer.addressInfo.floor;
      this.addressInfo.door = offer.addressInfo.door;

      this.cupsInfo.electricityCups = offer.electricityCups;
      this.cupsInfo.gasCups = offer.gasCups;
      this.offerInfo.flexiOffer = offer.flexiOffer;
      this.offerInfo.fijoOffer = offer.fijoOffer;
      this.offerInfo.simpleOffer = offer.simpleOffer;
      this.offerInfo.hoyOffer = offer.hoyOffer;
      this.offerInfo.gasOffer = offer.gasOffer;
      this.offerInfo.gasSimpleOffer = offer.gasSimpleOffer;
      this.offerInfo.gasHoyOffer = offer.gasHoyOffer;
      this.optimizedOfferPower = offer.optimizedOfferPower;
      this.leadSource = offer.leadSource;
      this.checkEnergiaVerde = offer.checkEnergiaVerde;

      // Valores fomateados
      if (this.offerInfo.flexiOffer != null) {
        // this.offerInfo.flexiOffer.p_contratada_electricidad_Formated = this.formatValue(
        //   this.offerInfo.flexiOffer.p_contratada_electricidad
        // );
        this.offerInfo.flexiOffer.p_contratada_electricidad_Formated = this.offerInfo.flexiOffer.p_contratada_electricidad;
        // this.offerInfo.flexiOffer.luzp1simp_Formated = this.formatValue(
        //   this.offerInfo.flexiOffer.luzp1simp
        // );
        this.offerInfo.flexiOffer.luzp1simp_Formated = this.offerInfo.flexiOffer.luzp1simp;

        // this.offerInfo.flexiOffer.luzp1cimp_Formated = this.formatValue(
        //   this.offerInfo.flexiOffer.luzp1cimp
        // );
        this.offerInfo.flexiOffer.luzp1cimp_Formated = this.offerInfo.flexiOffer.luzp1cimp;

        this.offerInfo.flexiOffer.cuota_luz_simp_Formated = this.formatValue(
          this.offerInfo.flexiOffer.cuota_luz_simp
        );
        this.offerInfo.flexiOffer.cuota_luz_cimp_Formated = this.formatValue(
          this.offerInfo.flexiOffer.cuota_luz_cimp
        );
      }
      if (this.offerInfo.fijoOffer != null) {
        // this.offerInfo.fijoOffer.p_contratada_electricidad_Formated = this.formatValue(
        //   this.offerInfo.fijoOffer.p_contratada_electricidad
        this.offerInfo.fijoOffer.p_contratada_electricidad_Formated = this.offerInfo.fijoOffer.p_contratada_electricidad;
        this.offerInfo.fijoOffer.luzp1simp_Formated = this.offerInfo.fijoOffer.luzp1simp;
        // this.offerInfo.fijoOffer.luzp1cimp_Formated = this.formatValue(
        //   this.offerInfo.fijoOffer.luzp1cimp
        // );
        this.offerInfo.fijoOffer.luzp1cimp_Formated = this.offerInfo.fijoOffer.luzp1cimp;

        this.offerInfo.fijoOffer.cuota_luz_simp_Formated = this.formatValue(
          this.offerInfo.fijoOffer.cuota_luz_simp
        );
        this.offerInfo.fijoOffer.cuota_luz_cimp_Formated = this.formatValue(
          this.offerInfo.fijoOffer.cuota_luz_cimp
        );
      }

      if (this.offerInfo.hoyOffer != null) {
        // this.offerInfo.hoyOffer.p_contratada_electricidad_Formated = this.formatValue(
        //   this.offerInfo.hoyOffer.p_contratada_electricidad
        this.offerInfo.hoyOffer.p_contratada_electricidad_Formated = this.offerInfo.hoyOffer.p_contratada_electricidad;
        this.offerInfo.hoyOffer.luzp1simp_Formated = this.offerInfo.hoyOffer.luzp1simp;
        // this.offerInfo.hoyOffer.luzp1cimp_Formated = this.formatValue(
        //   this.offerInfo.hoyOffer.luzp1cimp
        // );
        this.offerInfo.hoyOffer.luzp1cimp_Formated = this.offerInfo.hoyOffer.luzp1cimp;

        this.offerInfo.hoyOffer.cuota_luz_simp_Formated = this.formatValue(
          this.offerInfo.hoyOffer.cuota_luz_simp
        );
        this.offerInfo.hoyOffer.cuota_luz_cimp_Formated = this.formatValue(
          this.offerInfo.hoyOffer.cuota_luz_cimp
        );
      }

      if (this.offerInfo.simpleOffer != null) {
        // this.offerInfo.simpleOffer.p_contratada_electricidad_Formated = this.formatValue(
        //   this.offerInfo.simpleOffer.p_contratada_electricidad
        this.offerInfo.simpleOffer.p_contratada_electricidad_Formated = this.offerInfo.simpleOffer.p_contratada_electricidad;
        this.offerInfo.simpleOffer.luzp1simp_Formated = this.offerInfo.simpleOffer.luzp1simp;
        // this.offerInfo.simpleOffer.luzp1cimp_Formated = this.formatValue(
        //   this.offerInfo.simpleOffer.luzp1cimp
        // );
        this.offerInfo.simpleOffer.luzp1cimp_Formated = this.offerInfo.simpleOffer.luzp1cimp;

        this.offerInfo.simpleOffer.cuota_luz_simp_Formated = this.formatValue(
          this.offerInfo.simpleOffer.cuota_luz_simp
        );
        this.offerInfo.simpleOffer.cuota_luz_cimp_Formated = this.formatValue(
          this.offerInfo.simpleOffer.cuota_luz_cimp
        );
      }

      if (this.offerInfo.gasOffer != null) {
        this.offerInfo.gasOffer.gassimp_Formated = this.formatValue(
          this.offerInfo.gasOffer.gassimp
        );
        this.offerInfo.gasOffer.gascimp_Formated = this.formatValue(
          this.offerInfo.gasOffer.gascimp
        );
        this.offerInfo.gasOffer.cuota_gas_simp_Formated = this.formatValue(
          this.offerInfo.gasOffer.cuota_gas_simp
        );
        this.offerInfo.gasOffer.cuota_gas_cimp_Formated = this.formatValue(
          this.offerInfo.gasOffer.cuota_gas_cimp
        );
      }

      if(this.offerInfo.gasHoyOffer){
        this.offerInfo.gasHoyOffer.gassimp_Formated = this.formatValue(
          this.offerInfo.gasHoyOffer.gassimp
        );
        this.offerInfo.gasHoyOffer.gascimp_Formated = this.formatValue(
          this.offerInfo.gasHoyOffer.gascimp
        );
        this.offerInfo.gasHoyOffer.cuota_gas_simp_Formated = this.formatValue(
          this.offerInfo.gasHoyOffer.cuota_gas_simp
        );
        this.offerInfo.gasHoyOffer.cuota_gas_cimp_Formated = this.formatValue(
          this.offerInfo.gasHoyOffer.cuota_gas_cimp
        );
      }

      if(this.offerInfo.gasSimpleOffer){
        this.offerInfo.gasSimpleOffer.gassimp_Formated = this.formatValue(
          this.offerInfo.gasSimpleOffer.gassimp
        );
        this.offerInfo.gasSimpleOffer.gascimp_Formated = this.formatValue(
          this.offerInfo.gasSimpleOffer.gascimp
        );
        this.offerInfo.gasSimpleOffer.cuota_gas_simp_Formated = this.formatValue(
          this.offerInfo.gasSimpleOffer.cuota_gas_simp
        );
        this.offerInfo.gasSimpleOffer.cuota_gas_cimp_Formated = this.formatValue(
          this.offerInfo.gasSimpleOffer.cuota_gas_cimp
        );
      }

    }
  },
  data() {
    const nifRule = (rule, value, callback) => {
      console.log("Regla nif -> " + value);
      if (!value) {
        callback(new Error("Por favor rellena este campo"));
        return;
      }
      if (!this.checkDocumentacion(value)) {
        callback(new Error("Por favor introduce un documento válido"));
      } else {
        //la llamada a nationalities la debo hacer aquí
        //getNationalities();
        callback();
      }
    };

    const nationalityRule = (rule, value, callback) => {
      console.log("Regla nacionalidad -> " + value);
      if (!value || value.length <= 0 || value == "") {
        callback(new Error("Por favor, introduce una nacionalidad"));
      } else {
        callback();
      }
    };

    const particularRule = (rule, value, callback) => {
      console.log("Regla de checkParticular -> " + value);
      if (!value && (this.personalInfo.checkEmpresa == false || this.personalInfo.checkEmpresa == undefined)) {
        callback(
          new Error("Es obligatorio seleccionar una opción Particular/Empresa")
        );
      } else {
        console.log("Hay alguna seleccionada");
        callback();
      }
    };

    const empresaRule = (rule, value, callback) => {
      console.log("Regla de checkEmpresa -> " + value);
      if (!value && (this.personalInfo.checkParticular == false|| this.personalInfo.checkParticular == undefined)) {
        callback(
          new Error("Es obligatorio seleccionar una opción Particular/Empresa")
        );
      } else {
        console.log("Hay alguna seleccionada");
        callback();
      }
    };

    const ibanRule = (rule, value, callback) => {
      if (!value) {
        callback(new Error("Por favor rellena este campo"));
      } else if (!this.validateIBAN(value)) {
        callback(new Error("El IBAN introducido no es válido"));
      } else {
        callback();
      }
    };

    const provinceRule = (rule, value, callback) => {
      this.provinceValidation = false;
      if (!value || value.length <= 0) {
        callback(new Error("Por favor rellena este campo"));
      } else {
        this.provinceValidation = true;
        callback();
      }
    };

    const postalCodeRule = (rule, value, callback) => {
      this.postalCodeValidation = false;
      if (!value) {
        callback(new Error("Por favor rellena este campo"));
      } else if (value.length != 5 || !Number(value)) {
        callback(new Error("El código postal introducido no es válido"));
      } else {
        this.postalCodeValidation = true;
        callback();
      }
    };

    const checkRule = (rule, value, callback) => {
      if (!value) {
        callback(
          new Error("Es obligatorio aceptar el inicio inmediato del servicio")
        );
      } else {
        callback();
      }
    };

    return {
      title: "CONTRATACIÓN",
      showIframeModal: false,
      iframeURL: "",
      idCircuit: "",
      showModal: false,
      showPrivacyPolicyModal: false,
      urlPdf: BASE_URL,
      cancelModal: false,
      showModalMsg: false,
      modalMsgContent: "",
      showModalEnd: false,
      modalEndMsg: "",
      showErrorValidationModal: false,
      errorsValidation: null,
      provinceValidation: false,
      postalCodeValidation: false,
      nationalities: null,
      personalInfo: {
        name: null,
        lastName: null,
        email: null,
        phone: null,
        phone2: null,
        documentType: [
          { label: "DNI", value: "NIF" },
          { label: "CIF", value: "CIF" },
          { label: "NIE", value: "NIE" },
          { label: "PASAPORTE", value: "PASAPORTE" }
        ],
        documentTypeSelected: "NIF",
        documentValue: null,
        nationality: null,
        checkParticular: false,
        checkEmpresa: false,
      },
      addressInfo: {
        location: null,
        province: null,
        postalCode: null,
        address: null,
        number: null,
        portal: null,
        stair: null,
        floor: null,
        door: null
      },
      cupsInfo: {
        electricityCups: null,
        gasCups: null
      },
      offerInfo: {
        flexiOffer: null,
        fijoOffer: null,
        simpleOffer: null,
        hoyOffer: null,
        gasOffer: null,
        gasSimpleOffer: null,
        gasHoyOffer: null,
      },
      ibanInfo: {
        iban: null
      },
      checkInfo: {
        serviceCheck: false,
        comercialCheck: false,
        customOffersCheck: false
      },
      optimizedOfferPower: true,
      leadSource: null,
      checkEnergiaVerde: false,
      personalInfoRules: {
        documentValue: {
          required: true,
          validator: nifRule,
          trigger: "blur"
        },
        nationality: {
          required: true,
          validator: nationalityRule,
          trigger: "blur",
        },
        checkParticular: {
          required: true,
          validator: particularRule,
          trigger: "blur",
        },
        checkEmpresa: {
          required: false,
          validator: empresaRule,
          trigger: "blur",
        }
      },
      ibanRules: {
        iban: {
          required: true,
          validator: ibanRule,
          trigger: "blur"
        }
      },
      addressRules: {
        province: {
          required: true,
          validator: provinceRule,
          trigger: "blur"
        },
        postalCode: {
          required: true,
          validator: postalCodeRule,
          trigger: "blur"
        }
      },
      checkInfoRules: {
        serviceCheck: {
          required: true,
          validator: checkRule,
          trigger: "blur"
        }
      },
    };
  },
  methods: {
    checkDocumentacion(nif) {
      const character = [
        "T",
        "R",
        "W",
        "A",
        "G",
        "M",
        "Y",
        "F",
        "P",
        "D",
        "X",
        "B",
        "N",
        "J",
        "Z",
        "S",
        "Q",
        "V",
        "H",
        "L",
        "C",
        "K",
        "E"
      ];
      const nifNumber = nif.substring(0, 8);
      const nifCharacter = nif.substring(8, 9).toUpperCase();

      if (this.personalInfo.documentTypeSelected === "NIF") {
        if (!this.validaDni(nif)) {
          return false;
        } else {
          return true;
        }
      } else if (this.personalInfo.documentTypeSelected === "CIF") {
        if (!this.validaCif(nif)) {
          return false;
        } else {
          return true;
        }
      } else if (this.personalInfo.documentTypeSelected === "NIE") {
        if (!this.validaNie(nif)) {
          return false;
        } else {
          return true;
        }
      } else if (this.personalInfo.documentTypeSelected === "PASAPORTE") {
        if (!this.validaPasaporte(nif)) {
          return false;
        } else {
          return true;
        }
      }

      // if (this.personalInfo.documentTypeSelected === "NIE") {
      //   nifNumber = nifNumber
      //     .replace("X", 0)
      //     .replace("Y", 1)
      //     .replace("Z", 2);
      // }
      return character[nifNumber % 23] === nifCharacter;
    },
    validaDni(dni) {
      let number;
      let letra;
      let nif_codes = "TRWAGMYFPDXBNJZSQVHLCKET";
      const regular_expresion_dni = /^\d{8}[a-zA-Z]$/;
      if (regular_expresion_dni.test(dni) === true) {
        number = dni.substr(0, dni.length - 1);
        letra = dni.substr(dni.length - 1, 1);
        number = number % 23;
        nif_codes = nif_codes.substring(number, number + 1);
        if (nif_codes !== letra.toUpperCase()) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    validaCif(dni) {
      let resul = false;
      const temp = dni.toUpperCase(); // pasar a mayúsculas
      if (!/^[A-Za-z0-9]{9}$/.test(temp)) {
        // Son 9 dígitos?
        console.log("Longitud incorrecta, un CIF consta de 9 dígitos");
      } else if (!/^[ABCDEFGHJKLMNPQRSUVW]/.test(temp)) {
        // Es una letra de las admitidas ?
        console.log(
          "El primer dígito es incorrecto, debe ser una letra de las siguientes: A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,S,U,V,W "
        );
      } else {
        resul = true;
      }
      return resul;
    },
    validaNie(dni) {
      // Change the initial letter for the corresponding number and validate as DNI
      let nie_prefix = dni.charAt(0);

      switch (nie_prefix) {
        case "X":
          nie_prefix = 0;
          break;
        case "Y":
          nie_prefix = 1;
          break;
        case "Z":
          nie_prefix = 2;
          break;
      }
      return this.validaDni(nie_prefix + dni.substr(1));
    },
    validaPasaporte(dni) {
      let result = false;
      const temp = dni.toUpperCase(); // pasar a mayúsculas
      if (!/^[a-zA-Z0-9]+$/.test(temp)) {
        console.log("Solo se permiten dígitos y letras");
      } else {
        result = true;
      }

      return result;
    },

    /* Método de validación de código IBAN para España */
    validateIBAN(IBAN) {
      // Se pasa a mayusculas, se quitan los blancos de principio y final, y se eliminan los espacios en blnaco dentro de la cadena
      IBAN = IBAN.toUpperCase();
      IBAN = IBAN.trim();
      IBAN = IBAN.replace(/\s/g, "");

      let isbanaux;
      let numeroSustitucion;
      // La longitud debe ser siempre de 24 caracteres
      if (IBAN.length != 24) {
        return false;
      }

      // Se coge las primeras dos letras y se pasan a números
      const num1 = this.getnumIBAN(IBAN.substring(0, 1));
      const num2 = this.getnumIBAN(IBAN.substring(1, 2));
      //Se sustituye las letras por números
      isbanaux = String(num1) + String(num2) + IBAN.substring(2);
      // Se mueven los 6 primeros caracteres al final de la cadena
      isbanaux = isbanaux.substring(6) + isbanaux.substring(0, 6);

      //Se calcula el resto (llamando a la función modulo97)
      const resto = this.modulo97(isbanaux);
      if (resto == 1) {
        return true;
      } else {
        return false;
      }
    },
    getNationalities() {
      offerService
        .getNationalities(this.personalInfo.documentValue)
        .then(response => {
          if (response.data.data.length > 0) {
            this.nationalities = response.data.data.map(na => {
              return {
                label: na.name,
                value: na.codigo
              };
            });
          } else {
            this.nationalities = [];
            this.addressLabel = "No se ha encontrado ninguna dirección";
            this.$notify({
              title: "Sin resultados",
              message:
                "No se han encontrado resultados para la dirección introducida",
              type: "error",
              duration: 3000
            });
          }
        })
        .catch(() => {
          this.addresses = [];
          this.addressLabel = "No se ha encontrado ninguna dirección";
          this.$notify({
            title: "Sin resultados",
            message:
              "No se han encontrado resultados para la dirección introducida",
            type: "error",
            duration: 3000
          });
        });
    },

    empresaChecked(){
      console.log("Cambio empresa");
      this.personalInfo.checkParticular = false;
      if(this.personalInfo.checkEmpresa == true){
        console.log("Empresa checked");
        console.log("Particular no obligatorio");
        this.personalInfoRules.checkParticular.required = false;
      }else{
        console.log("Empresa no checked");
        console.log("Particular obligatorio");
        this.personalInfoRules.checkParticular.required = true;
        this.personalInfoRules.checkEmpresa.required = true;
      }
    },
    particularChecked(){
      console.log("Cambio particular");
      this.personalInfo.checkEmpresa = false;
      if(this.personalInfo.checkParticular == true){
        console.log("Particular checked");
        console.log("Empresa no obligatorio");
        this.personalInfoRules.checkEmpresa.required = false;
      }else{
        console.log("Particular no checked")
        console.log("Empresa obligatorio");
        this.personalInfoRules.checkParticular.required = true;
        this.personalInfoRules.checkEmpresa.required = true;
      }
    },

    /* Método auxiliar de validación del código IBAN */
    modulo97(iban) {
      const parts = Math.ceil(iban.length / 7);
      let remainer = "";
      for (let i = 1; i <= parts; i++) {
        remainer = String(
          parseFloat(remainer + iban.substr((i - 1) * 7, 7)) % 97
        );
      }
      return remainer;
    },
    /* Método auxiliar de validación del código IBAN */
    getnumIBAN(letra) {
      const ls_letras = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      return ls_letras.search(letra) + 10;
    },
    clearNif() {
      this.personalInfo.documentValue = null;
    },
    acceptButton() {
      localStorage.removeItem("offer");
      localStorage.removeItem("newClient");
      setTimeout(() => {
        this.$router.push("/new-client");
      }, 150);
    },

    sendContract() {
      console.log("IMPRIMO LA NACIONALIDAD -> " + this.nationality);
      console.log("IMPRIMO LA PERSONAL INFONACIONALIDAD -> " + this.personalInfo.nationality);
      this.$refs["personalInfoForm"].validate(validNIF => {
        this.$refs["personalInfoForm"].validate(validNationality => {
          this.$refs["personalInfoForm"].validate(validCheckParticularEmpresa => {
            this.$refs["ibanInfoForm"].validate(validIBAN => {  
              this.$refs["addressInfoForm"].validate(validAddressInfo => {
                this.$refs["checkInfoForm"].validate(validCheck => {
                if (validNIF && validNationality && validCheckParticularEmpresa && validIBAN && validAddressInfo && validCheck) {

                //compruebo qué información llevo en el select de nacionalidad

                const loadingInstance = Loading.service({ fullscreen: true });
                ContractService.sendContract({
                  additionalInfo: {
                    address: this.addressInfo.address, //"CL MONASTERIO DE POYO 4, Esc: 2, 4º B",
                    cups: this.cupsInfo.electricityCups, //"ES0031300031580001BK0F",
                    documentNumber: this.personalInfo.documentValue, //"70563025Y",
                    documentType: this.personalInfo.documentTypeSelected, //"NIF",
                    email: this.personalInfo.email,
                    fare: this.getFare(), //es de la oferta de luz --> peaje_luz
                    phoneNumber: this.personalInfo.phone, //"600000000",
                    phoneNumber2: this.personalInfo.phone2,
                    state: "", // --> ?? de momento dejarlo vacio ""
                    postal_code: this.addressInfo.postalCode, //"31002",
                    ReferralProgram: "",
                    ambassador: "",
                    name: this.personalInfo.name,
                    firstNameOrSocialName: this.personalInfo.lastName, // en a3mbos van apellidos
                    secondName: this.personalInfo.lastName, // (arriba)
                    iban: this.ibanInfo.iban, //"ES9000246912501234567891"
                    nationality: this.personalInfo.nationality
                  },
                  product: this.getProduct(), //"FIJO",
                  potenciaOptimizada: this.optimizedOfferPower, // coger del mounted
                  leadSource: this.leadSource,
                  input: {
                    // en oferta de luz y gas o en formulario
                    firstName: this.personalInfo.name,
                    lastName: this.personalInfo.lastName,
                    email: this.personalInfo.email,
                    phone: this.personalInfo.phone,
                    phone2: this.personalInfo.phone2,
                    city: this.addressInfo.location, //"madrid",
                    province: this.addressInfo.province, //"madrid",
                    address: this.addressInfo.address, //"CL MONASTERIO DE POYO 4, Esc: 2, 4º B",
                    number: this.addressInfo.number, //"4",
                    portal: this.addressInfo.portal, //"IZQ",
                    stair: this.addressInfo.stair, //"ESC 2",
                    floor: this.addressInfo.floor, //"4",
                    door: this.addressInfo.door, //"C",
                    nationality: this.personalInfo.nationality, //"ES"
                    checkParticular: this.personalInfo.checkParticular,
                    checkEmpresa: this.personalInfo.checkEmpresa,
                    luzp1simp: this.getLuzSimp(), //"0,1150",  // flexi o fijo ----> cogerlo de donde sea
                    luzp1cimp: this.getLuzCimp(), //"0,1460",
                    margenIndexLuzCimp: this.getMargenIndexLuzCimp(),
                    margenIndexLuzSimp: this.getMargenIndexLuzSimp(),
                    margenIndexGasCimp: this.getMargenIndexGasCimp(),
                    margenIndexGasSimp: this.getMargenIndexGasSimp(),
                    checkEnergiaVerde: this.checkEnergiaVerde,
                    // contadorSimp:
                    // contadorCimp:
                    peajegas: this.getPeajeGas(),
                    gassimp: this.getGassimp(),
                    gascimp: this.getGascimp(),
                    nif: this.personalInfo.documentValue, //"70707070A",
                    iban: this.ibanInfo.iban, //"ES9000246912501234567891",
                    postalCod: this.addressInfo.postalCode, //"30000",
                    cups: this.cupsInfo.electricityCups, //coger de oferta electricidad (mounted)
                    cupsGas: this.getCupsgas(),
                    checkInitService: this.checkInfo.serviceCheck,
                    checkReceiveCommunications: this.checkInfo.comercialCheck,
                    checkReceiveOffers: this.checkInfo.customOffersCheck,
                    cuota_luz_simp: this.getCuotaLuzSimp(), //"14", // discernir entyre ambas electricidad
                    cuota_luz_cimp: this.getCuotaLuzCimp(), //"18",
                    p_contratada_electricidad: this.getPContratatadaElectricidad(), //"3,45", // discernir entyre ambas electricidad
                    cuota_gas_simp: this.getCuotaGasSimp(),
                    cuota_gas_cimp: this.getCuotaGasCimp(),
                      pnueva1:this.getPContratatadaElectricidad(),
                      pnueva2:this.getPContratatadaElectricidad(),
                      
                  },
                  cups: this.cupsInfo.electricityCups, // cups electricidad
                  cupsGas: this.getCupsgas(),
                })
                  .then(response => {
                    // Abrimos la URL de respuesta en el modal de iFrame...
                    this.iframeURL = response.data.data.publicOperation;
                    this.idCircuit = response.data.data.idCircuit
                    this.showIframeModal = true;
                    loadingInstance.close();
                    //this.modalMsgContent = "Contrato enviado correctamente";
                    //this.showModalMsg = true;
                  })
                  .catch(error => {
                    if (
                      error.response &&
                      error.response.data &&
                      error.response.data.code === "ERROR_SCORING"
                    ) {
                      this.modalMsgContent =
                        "El cliente no ha pasado la comprobación crediticia. El proceso no puede continuar.";
                      this.showModalMsg = true;
                    } else {
                      this.modalMsgContent =
                        "Se ha producido un error. Por favor intentalo de nuevo más tarde";
                      this.showModalMsg = true;
                    }
                    loadingInstance.close();
                  });
              } else {
                const messages = [];
                if (!validNIF) messages.push("NIF/NIE");
                if(!validNationality) messages.push("Nacionalidad");
                if(!validCheckParticularEmpresa) messages.push("Particular / Empresa");
                if (!validAddressInfo && !this.provinceValidation)
                  messages.push("Provincia");
                if (!validAddressInfo && !this.postalCodeValidation)
                  messages.push("Código postal");
                if (!validIBAN) messages.push("IBAN");
                if (!validCheck) messages.push("Inicio inmediato del servicio");
                this.errorsValidation = messages;
                this.showErrorValidationModal = true;
              }
            });
          });
        });
      });
      });
      });
    },
    getProduct() {
      let product = "";
      if (this.offerInfo.flexiOffer) {
        product += "FLEXI UNO";
      } else if (this.offerInfo.fijoOffer) {
        product += "FIJO";
      }else if(this.offerInfo.simpleOffer){
        product += "LUZ SIMPLE";
      }else if(this.offerInfo.hoyOffer){
        product += "FLEXI LUZ HOY";
      }
      if (this.offerInfo.gasOffer) {
        if(this.offerInfo.flexiOffer || this.offerInfo.fijoOffer || this.offerInfo.hoyOffer || this.offerInfo.simpleOffer){
          product += " + FLEXI GAS";
        }else{
          product += "FLEXI GAS";
        }
        
      }else if(this.offerInfo.gasSimpleOffer){
        if(this.offerInfo.flexiOffer || this.offerInfo.fijoOffer || this.offerInfo.hoyOffer || this.offerInfo.simpleOffer){
          product += " + GAS SIMPLE";
        }else{
          product += "GAS SIMPLE";
        }
      }else if(this.offerInfo.gasHoyOffer){
        if(this.offerInfo.flexiOffer || this.offerInfo.fijoOffer || this.offerInfo.hoyOffer || this.offerInfo.simpleOffer){
          product += " + FLEXI GAS HOY";
        }else{
          product += "FLEXI GAS HOY";
        }
      }
      return product;
    },
    getFare() {
      if (this.offerInfo.flexiOffer) {
        return this.offerInfo.flexiOffer.peajeluz;
      } else if (this.offerInfo.fijoOffer) {
        return this.offerInfo.fijoOffer.peajeluz;
      }else if(this.offerInfo.hoyOffer){
        return this.offerInfo.hoyOffer.peajeluz;
      }else if(this.offerInfo.simpleOffer){
        return this.offerInfo.simpleOffer.peajeluz;
      }
      return null;
    },
    getLuzSimp() {
      if (this.offerInfo.flexiOffer) {
        // return;
          return this.offerInfo.flexiOffer.luzp1simp_Formated;
      } else if (this.offerInfo.fijoOffer) {
        return this.offerInfo.fijoOffer.luzp1simp_Formated;
        //return this.offerInfo.fijoOffer.luzp1simp_Formated;
      }else if(this.offerInfo.hoyOffer){
        return this.offerInfo.hoyOffer.luzp1simp_Formated;
      }else if(this.offerInfo.simpleOffer){
        return this.offerInfo.simpleOffer.luzp1simp_Formated;
      }
      return null;
    },
    getLuzCimp() {
      if (this.offerInfo.flexiOffer) {
        return this.offerInfo.flexiOffer.luzp1cimp_Formated;
      } else if (this.offerInfo.fijoOffer) {
        return this.offerInfo.fijoOffer.luzp1cimp_Formated;
      }else if(this.offerInfo.hoyOffer){
        return this.offerInfo.hoyOffer.luzp1cimp_Formated;
      }else if(this.offerInfo.simpleOffer){
        return this.offerInfo.simpleOffer.luzp1cimp_Formated;
      }
      return null;
    },
    getCuotaLuzSimp() {
      if (this.offerInfo.flexiOffer) {
        return this.offerInfo.flexiOffer.cuota_luz_simp_Formated;
      } else if (this.offerInfo.fijoOffer) {
        return this.offerInfo.fijoOffer.cuota_luz_simp_Formated;
      }else if(this.offerInfo.hoyOffer){
        return this.offerInfo.hoyOffer.cuota_luz_simp_Formated;
      }else if(this.offerInfo.simpleOffer){
        return this.offerInfo.simpleOffer.cuota_luz_simp_Formated;
      }
      return null;
    },
    getCuotaLuzCimp() {
      if (this.offerInfo.flexiOffer) {
        return this.offerInfo.flexiOffer.cuota_luz_cimp_Formated;
      } else if (this.offerInfo.fijoOffer) {
        return this.offerInfo.fijoOffer.cuota_luz_cimp_Formated;
      }else if(this.offerInfo.hoyOffer){
        return this.offerInfo.hoyOffer.cuota_luz_cimp_Formated;
      }else if(this.offerInfo.simpleOffer){
        return this.offerInfo.simpleOffer.cuota_luz_cimp_Formated;
      }
      return null;
    },
    getPContratatadaElectricidad() {
      if (this.offerInfo.flexiOffer) {
        return this.offerInfo.flexiOffer.p_contratada_electricidad_Formated;
      } else if (this.offerInfo.fijoOffer) {
        return this.offerInfo.fijoOffer.p_contratada_electricidad_Formated;
      }else if(this.offerInfo.hoyOffer){
        return this.offerInfo.hoyOffer.p_contratada_electricidad_Formated;
      }else if(this.offerInfo.simpleOffer){
        return this.offerInfo.simpleOffer.p_contratada_electricidad_Formated;
      }
      return null;
    },
    getMargenIndexLuzCimp(){
      if(this.offerInfo.hoyOffer){
        return this.offerInfo.hoyOffer.margen_index_cimp;
      }else if(this.offerInfo.simpleOffer){
        return this.offerInfo.simpleOffer.margen_index_cimp;
      }
      return null;
    },
    getMargenIndexLuzSimp(){
      if(this.offerInfo.hoyOffer){
        return this.offerInfo.hoyOffer.margen_index_simp;
      }else if(this.offerInfo.simpleOffer){
        return this.offerInfo.simpleOffer.margen_index_simp;
      }
      return null;
    },
    getMargenIndexGasCimp(){
      if(this.offerInfo.gasHoyOffer){
        return this.offerInfo.gasHoyOffer.margen_index_cimp;
      }else if(this.offerInfo.gasSimpleOffer){
        return this.offerInfo.gasSimpleOffer.margen_index_cimp;
      }
      return null;
    },
    getMargenIndexGasSimp(){
      if(this.offerInfo.gasHoyOffer){
        return this.offerInfo.gasHoyOffer.margen_index_simp;
      }else if(this.offerInfo.gasSimpleOffer){
        return this.offerInfo.gasSimpleOffer.margen_index_simp;
      }
      return null;
    },
    getPeajeGas(){
      if(this.offerInfo.gasOffer){
        return this.offerInfo.gasOffer.peajegas;
      }else if(this.offerInfo.gasSimpleOffer){
        return this.offerInfo.gasSimpleOffer.peajegas;
      }else if(this.offerInfo.gasHoyOffer){
        return this.offerInfo.gasHoyOffer.peajegas;
      }
      return null;
    },
    getGassimp(){
      if(this.offerInfo.gasOffer){
        return this.offerInfo.gasOffer.gassimp_Formated
      }else if(this.offerInfo.gasSimpleOffer){
        return this.offerInfo.gasSimpleOffer.gassimp_Formated
      }else if(this.offerInfo.gasHoyOffer){
        return this.offerInfo.gasHoyOffer.gassimp_Formated
      }
      return null;
    },
    getGascimp(){
      if(this.offerInfo.gasOffer){
        return this.offerInfo.gasOffer.gascimp_Formated
      }else if(this.offerInfo.gasSimpleOffer){
        return this.offerInfo.gasSimpleOffer.gascimp_Formated
      }else if(this.offerInfo.gasHoyOffer){
        return this.offerInfo.gasHoyOffer.gascimp_Formated
      }
      return null;
    },
    getCupsgas(){
      if(this.offerInfo.gasOffer || this.offerInfo.gasSimpleOffer || this.offerInfo.gasHoyOffer){
        return this.cupsInfo.gasCups;
      }
      return null;
    },
    getCuotaGasSimp(){
      if(this.offerInfo.gasOffer){
        return this.offerInfo.gasOffer.cuota_gas_simp_Formated;
      }else if(this.offerInfo.gasSimpleOffer){
        return this.offerInfo.gasSimpleOffer.cuota_gas_simp_Formated;
      }else if(this.offerInfo.gasHoyOffer){
        return this.offerInfo.gasHoyOffer.cuota_gas_simp_Formated;
      }
      return null;
    },
    getCuotaGasCimp(){
      if(this.offerInfo.gasOffer){
        return this.offerInfo.gasOffer.cuota_gas_cimp_Formated;
      }else if(this.offerInfo.gasSimpleOffer){
        return this.offerInfo.gasSimpleOffer.cuota_gas_cimp_Formated;
      }else if(this.offerInfo.gasHoyOffer){
        return this.offerInfo.gasHoyOffer.cuota_gas_cimp_Formated;
      }
      return null;
    },
    formatValue(value) {
      if (
        Number.isInteger(value) ||
        (typeof value === "string" && value.includes(","))
      )
        return value;

      if (value) {
        const result = value.toString();
        return result.replace(".", ",");
      }
    },
    endContractMessage() {
      const loadingInstance = Loading.service({ fullscreen: true });
      ContractService.checkContract({
        idCircuit: this.idCircuit
      }).then(response => {

        this.showModalEnd = true;
        this.modalEndMsg = "Contrato enviado correctamente";
        loadingInstance.close();

      }).catch(error => {
              if (
                      error.response &&
                      error.response.data &&
                      error.response.data.data){
                        this.showModalEnd = true;
                        this.modalEndMsg = error.response.data.data;
                        loadingInstance.close();
                }else{
                        this.modalMsgContent = "El cliente no ha pasado la comprobación crediticia. El proceso no puede continuar.";
                        this.showModalMsg = true;
                        loadingInstance.close();
              }
          });

    },
    endContract() {
      this.showModalEnd = false;
      localStorage.removeItem("offer");
      localStorage.removeItem("newClient");
      setTimeout(() => {
        this.$router.push("/new-client");
      }, 150);
    },
    sessionExpired() {
      AuthService.sessionExpired();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/sass/styles";
#contract {
  width: 100%;
  height: auto;

  .box {
    background: $white-color;
    width: 100%;
    border: 1px solid #e8e8e8;
    padding: 35px;
  }

  .margin-space {
    margin-top: 84px;
  }

  .offer-normal-label {
    font-size: 18px;
    font-weight: 400;
    margin-top: 10px;
  }

  .offer-small-label {
    font-size: 16px;
    font-weight: 500;
    margin-top: 15px;
  }

  .offer-title-label {
    margin-left: 10px;
    font-size: 22px;
    font-weight: 600;
  }

  .offer-pink-label {
    color: #ff00b9;
  }

  @media (max-width: 1200px) {
    .margin-space {
      margin-top: 0;
    }
  }

  @media (max-width: 576px) {
    .offer-small-label {
      margin-top: 0;
      margin-bottom: 15px;
    }
  }
}
</style>

<style lang="scss">
#contract {
  .contract-check {
    label.el-checkbox {
      margin-bottom: 0;
    }

    .el-form-item__error {
      padding-top: 0px;
    }
  }
}

.iframe-div-container {
  height: 91%;
}

.iframe-modal-element {
  height: 100%;
  width: 100%;
}
</style>
